/**
 * @Author Heriberto Monterrubio <heri185403@gmail.com>
 * @Date 2020-Oct-27
 *
 * bestgob-client - orders.api.js
 **/
import {httpClient} from "./http-client";

/**
 * Obtiene listado de Ordenes de pago
 *
 * @param data
 * @returns {Promise<AxiosResponse<any>>}
 */
const getListByStatus = (data) => httpClient.post('/orden/list', data)

/**
 * Crea una nueva orden de pago para despues redireccion a pago en linea
 *
 * @param data
 * @returns {Promise<AxiosResponse<any>>}
 */
const create = (data) => httpClient.post('/orden/crear', data)

/**
 * Obtiene el estatus del pago despues que responde la url de pagos
 *
 * @param data
 * @returns {Promise<AxiosResponse<any>>}
 */
const getPaymentStatus = (data) => httpClient.post('/orden/pagado', data)

/**
 * Obtiene la información de una Orde de pago, para posteriormente actualizarlo
 *
 * @param data
 * @returns {Promise<AxiosResponse<any>>}
 */
const edit = (data) => httpClient.post('/orden/editar', data)

/**
 * Obtiene los detalles de tramites en la orden de pago
 *
 * @param data
 * @returns {Promise<AxiosResponse<any>>}
 */
const details = (data) => httpClient.post('/orden/detalles', data)

/**
 * Obtiene todos items del checkout
 *
 * @param data
 * @returns {Promise<AxiosResponse<any>>}
 */
const checkoutDetails = (data) => httpClient.post('/orden/checkout_detalles', data)

/**
 * Realiza el primer request para proceder con el pago de la orden
 *
 * @param data
 * @returns {Promise<AxiosResponse<any>>}
 */
const pay = (data) => httpClient.post('/orden/pagar', data)

/**
 * Cancela una orden de pago
 *
 * @param data
 * @returns {Promise<AxiosResponse<any>>}
 */
const cancel = (data) => httpClient.post('/orden/cancelar', data)

/**
 * Realiza una solicitud para generar factura de la orden
 *
 * @param data
 * @returns {Promise<AxiosResponse<any>>}
 */
const generateInvoice = (data) => httpClient.post('/orden/facturar', data)

export {
    getListByStatus,
    create,
    getPaymentStatus,
    edit,
    details,
    checkoutDetails,
    pay,
    cancel,
    generateInvoice
}